/* Saatchi Watch — collection page. Filtering, sorting, view switch, load more. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const DESIGN = !!(window.Shopify && window.Shopify.designMode);
const say = m => { let r = $('#clLive'); if (!r) { r = document.createElement('div'); r.id = 'clLive'; r.className = 'sr'; r.setAttribute('aria-live', 'polite'); r.setAttribute('role', 'status'); document.body.appendChild(r); } r.textContent = ''; setTimeout(() => { r.textContent = m; }, 60); };
const kick = el => el && el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));

function boot(sec) {
  if (sec._sw) return; sec._sw = 1;
  const id = sec.dataset.section;
  const grid = () => $('[data-grid]', sec);
  let ctrl;

  /* ---- render a new URL into the section ---- */
  async function render(url, { push = true, append = false, focus = null } = {}) {
    const g = grid(); if (g) g.classList.add('sw-busy');
    sec.setAttribute('aria-busy', 'true');
    ctrl?.abort(); ctrl = new AbortController();
    try {
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${id}`, { signal: ctrl.signal });
      if (!res.ok) throw new Error('bad response');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      if (append) {
        const src = doc.querySelector('[data-grid]');
        const cards = src ? [...src.children] : [];
        const seen = new Set($$('[data-grid] > [data-handle]', sec).map(n => n.dataset.handle));
        const add = cards.filter(c => !c.dataset.handle || !seen.has(c.dataset.handle));
        const base = $$('[data-grid] > *', sec).length;
        add.forEach((c, i) => { c.style.setProperty('--i', Math.min(i, 10)); g.appendChild(c); });
        const nb = doc.querySelector('[data-loadmore]'), cb = $('[data-loadmore]', sec);
        if (cb) { if (nb) cb.replaceWith(nb); else cb.closest('.cl-load')?.remove(); }
        const np = doc.querySelector('[data-progress]'), cp = $('[data-progress]', sec);
        if (np && cp) cp.replaceWith(np);
        say(`${add.length} more products loaded. ${base + add.length} showing.`);
        if (add[0]) { const h = add[0].querySelector('a'); h && h.setAttribute('data-first-new', ''); }
      } else {
        $$('[data-swap]', sec).forEach(el => { const n = doc.querySelector(`[data-swap="${el.dataset.swap}"]`); if (n) el.replaceWith(n); });
        say($('[data-count-text]', sec)?.textContent || 'Results updated');
      }
      if (push) history.pushState({ swUrl: url }, '', url);
      wire(); kick(sec);
      if (focus) { const f = $(focus, sec); f && f.focus({ preventScroll: true }); }
    } catch (e) {
      if (e.name !== 'AbortError') location.href = url;
    } finally {
      sec.removeAttribute('aria-busy'); grid()?.classList.remove('sw-busy');
    }
  }

  /* ---- read the current filter/sort state from any form ---- */
  const formUrl = form => {
    const fd = new FormData(form), p = new URLSearchParams();
    for (const [k, v] of fd.entries()) if (String(v).trim() !== '') p.append(k, v);
    p.delete('page');
    return `${sec.dataset.url}?${p.toString()}`;
  };

  function wire() {
    /* filter forms — desktop sidebar and mobile drawer */
    $$('[data-filter-form]', sec).forEach(form => {
      if (form._w) return; form._w = 1;
      form.addEventListener('input', e => {
        if (e.target.type === 'number') return;
        if (form.dataset.live === 'false') { count(form); return; }
        render(formUrl(form), { focus: e.target.id ? `#${CSS.escape(e.target.id)}` : null });
      });
      form.addEventListener('change', e => { if (e.target.type === 'number' && form.dataset.live !== 'false') render(formUrl(form)); });
      form.addEventListener('submit', e => { e.preventDefault(); render(formUrl(form)); closeDrawer(); });
      form.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target.type === 'number') { e.preventDefault(); form.dataset.live === 'false' ? count(form) : render(formUrl(form)); } });
    });
    /* preview count for the mobile drawer's Apply button */
    async function count(form) {
      const btn = $('[data-apply]', form); if (!btn) return;
      btn.classList.add('is-busy');
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(`${formUrl(form)}&section_id=${id}`)).text(), 'text/html');
        const n = doc.querySelector('[data-count-text]')?.textContent?.trim();
        if (n) $('span', btn).textContent = `Show ${n}`;
      } catch (e) {} finally { btn.classList.remove('is-busy'); }
    }
    /* sort */
    $$('[data-sort]', sec).forEach(sel => {
      if (sel._w) return; sel._w = 1;
      sel.addEventListener('change', () => {
        const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
        render(u.pathname + u.search, { focus: '[data-sort]' });
      });
    });
    /* remove one filter / clear all */
    $$('[data-chip]', sec).forEach(a => {
      if (a._w) return; a._w = 1;
      a.addEventListener('click', e => { e.preventDefault(); render(a.getAttribute('href')); });
    });
    /* load more */
    const lm = $('[data-loadmore]', sec);
    if (lm && !lm._w) {
      lm._w = 1;
      lm.addEventListener('click', () => { lm.classList.add('is-busy'); render(lm.dataset.next, { append: true, push: sec.dataset.paginate === 'infinite' }); });
      if (sec.dataset.paginate === 'infinite') {
        const io = new IntersectionObserver(es => { if (es[0].isIntersecting && !lm.classList.contains('is-busy')) { io.disconnect(); lm.click(); } }, { rootMargin: '600px' });
        io.observe(lm);
      }
    }
    /* grid view */
    $$('[data-view]', sec).forEach(b => {
      if (b._w) return; b._w = 1;
      b.addEventListener('click', () => {
        const v = b.dataset.view, g = grid();
        $$('[data-view]', sec).forEach(x => x.setAttribute('aria-pressed', x === b));
        g.classList.toggle('one-up', v === '1');
        g.style.setProperty('--mcols', v === '1' ? 1 : 2);
        try { localStorage.setItem('sw-view', v); } catch (e) {}
      });
    });
    /* drawer */
    $$('[data-open-filters]', sec).forEach(b => { if (!b._w) { b._w = 1; b.addEventListener('click', () => openDrawer(b)); } });
    $$('[data-close-filters]', sec).forEach(b => { if (!b._w) { b._w = 1; b.addEventListener('click', closeDrawer); } });
  }

  /* ---- drawer focus handling ---- */
  let opener = null;
  const dr = () => $('[data-drawer]', sec);
  function openDrawer(btn) {
    const d = dr(); if (!d) return;
    opener = btn || document.activeElement;
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    $('#scrim')?.classList.add('on'); document.body.style.overflow = 'hidden';
    setTimeout(() => $('button, input, a', d)?.focus(), 80);
    document.addEventListener('keydown', keys);
  }
  function closeDrawer() {
    const d = dr(); if (!d || !d.classList.contains('on')) return;
    d.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
    if (!$$('.drawer.on, .qv.on').length) { $('#scrim')?.classList.remove('on'); document.body.style.overflow = ''; }
    document.removeEventListener('keydown', keys);
    opener?.focus();
  }
  function keys(e) {
    const d = dr(); if (!d || !d.classList.contains('on')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    const f = $$('a[href], button:not(:disabled), input:not(:disabled), select, summary, [tabindex]:not([tabindex="-1"])', d).filter(n => n.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  $('#scrim')?.addEventListener('click', closeDrawer);

  /* ---- sticky toolbar shadow ---- */
  const bar = $('[data-toolbar]', sec);
  if (bar) new IntersectionObserver(([e]) => bar.classList.toggle('stuck', e.intersectionRatio < 1), { threshold: [1] }).observe(bar);

  /* ---- restore saved mobile view ---- */
  try {
    const v = localStorage.getItem('sw-view');
    if (v) $(`[data-view="${v}"]`, sec)?.click();
  } catch (e) {}

  addEventListener('popstate', e => { if (e.state && e.state.swUrl !== undefined) render(location.pathname + location.search, { push: false }); });
  wire();
}

/* parallax for hero and story images, reusing the light-touch approach from sw.js */
function para(r = document) {
  if (RM) return;
  const items = $$('[data-cl-para]', r);
  if (!items.length) return;
  let tick = false;
  const run = () => {
    const vh = innerHeight, mob = matchMedia('(max-width: 900px)').matches;
    items.forEach(n => {
      const b = n.getBoundingClientRect(); if (b.bottom < -160 || b.top > vh + 160) return;
      const k = (+n.dataset.clPara || 10) / 100 * (mob ? .4 : 1);
      n.style.transform = `translate3d(0,${(-((b.top + b.height / 2 - vh / 2) / vh) * k * 100).toFixed(2)}px,0)`;
    });
    tick = false;
  };
  if (!para._on) { para._on = 1; addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true }); addEventListener('resize', run, { passive: true }); }
  run();
}

function init(r = document) { $$('[data-collection]', r).forEach(boot); para(r); }
document.addEventListener('shopify:section:load', e => init(e.target));
document.readyState === 'loading' ? addEventListener('DOMContentLoaded', () => init()) : init();
})();